import { Component, inject } from '@angular/core';
import { AuthService } from '../../../core/auth/auth.service';
import { AccountingDashboardComponent } from './accounting-dashboard.component';
import { SalesDashboardComponent } from './sales-dashboard.component';

@Component({
  selector: 'app-dashboard',
  imports: [AccountingDashboardComponent, SalesDashboardComponent],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent {
  readonly auth = inject(AuthService);
}
